import React, { useEffect, useState } from 'react';
import { motion, useScroll } from 'framer-motion';
export const StickyHeader = () => {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    return scrollY.onChange(latest => {
      setIsVisible(latest > 300);
    });
  }, [scrollY]);
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <motion.div initial={{
    y: -100
  }} animate={{
    y: isVisible ? 0 : -100
  }} transition={{
    duration: 0.3
  }} className="fixed left-0 right-0 top-0 z-50 border-b border-[#A855F7]/20 bg-white/90 px-4 py-3 backdrop-blur-md" data-id="element-313">
      <div className="mx-auto flex max-w-7xl items-center justify-between" data-id="element-314">
        <span className="font-heading text-sm font-bold text-[#6B21A8] sm:text-base" data-id="element-315">
          KIT HIJOS EN CALMA™
        </span>
        <button onClick={scrollToPricing} className="rounded-full bg-violet-gradient px-4 py-2 text-xs font-bold text-white shadow-btn-violet transition-transform hover:scale-105 sm:text-sm" data-id="element-316">
          OBTENER EL KIT — $19.990
        </button>
      </div>
    </motion.div>;
};